import { Swiper, SwiperSlide } from "swiper/react";


// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";

import { Navigation, EffectCoverflow } from "swiper";
import { motion } from 'framer-motion';


import fintech from '../../assets/developers/fintech.png'
import health from '../../assets/developers/health.png'
import nft from '../../assets/developers/nft.png'
import supplychain from '../../assets/developers/supply.png'
import realstate from '../../assets/developers/realstate.svg'

import { useMediaQuery } from "@mui/material";
import { StyledStoriesSection } from "./style";
import { useEffect, useRef, useState } from "react";
import { fadeIn, staggerContainer } from "../../utils/motion";


const data = [
    {
        title: 'NFT Industry',
        img: nft,
        desc: "The Non-Fungible Token (NFT) industry has rapidly gained popularity in recent years, particularly in the world of art and collectibles. NFTs are unique digital assets that are verified on a blockchain, which makes them one-of-a-kind and impossible to replicate."
    },
    {
        title: 'Health Industry',
        img: health,
        desc: "The health industry is a vast and complex sector that encompasses a range of disciplines, including medical research, healthcare services, pharmaceuticals, and medical devices. The industry is essential for ensuring the well-being and health of people worldwide."
    },
    {
        title: 'Fintech Industry',
        img: fintech,
        desc: "The fintech industry, short for financial technology, refers to the use of digital technology to create innovative financial services and products. The industry has experienced rapid growth in recent years, driven by increasing consumer demand for more accessible and convenient financial services."
    },
    {
        title: 'Supply Chain Industry',
        img: supplychain,
        desc: "The supply chain industry refers to the processes involved in producing and delivering goods and services to customers. It involves various stages, including sourcing of raw materials, manufacturing, transportation, warehousing, and distribution."
    },
    {
        title: 'Real Estate Industry',
        img: realstate,
        desc: "The real estate industry involves buying, selling, renting, and managing properties, including residential, commercial, and industrial properties. It is a critical sector of the economy that influences the wealth and well-being of individuals and businesses."
    },
]

const Stories = () => {

    const [currentSlide, setCurrentSlide] = useState(2);
    const smallerthen640 = useMediaQuery('(max-width:768px)')

    const swiperRef = useRef(null)

    useEffect(() => {

        swiperRef.current.swiper.slideToLoop(currentSlide);

    }, [currentSlide]);

    return (
        <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="show">
            <div className='max-w-screen-2xl mx-auto py-5 md:py-8 px-5 md:px-10'>
                <h1
                    className='text-xl dark:text-white md:text-2xl font-bold text-center'
                >
                    <span className='text-yellow-500'>Success</span> Stories
                </h1>
                <p className='text-center text-[15px] my-2 mx-auto md:max-w-[700px] dark:text-white'>
                    We work with your ideas to make an impact
                </p>

                <StyledStoriesSection>

                    <div className="md:w-[80%] mx-auto  my-6 md:my-10">
                        <Swiper
                            onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
                            grabCursor={true}
                            loop={true}
                            ref={swiperRef}
                            effect={"coverflow"}
                            centeredSlides={true}
                            slidesPerView={smallerthen640 ? 1 : 3}
                            speed={800}
                            navigation={true}
                            coverflowEffect={{
                                rotate: 50,
                                stretch: 0,
                                depth: 100,
                                modifier: 1,
                                slideShadows: true,
                            }}
                            modules={[Navigation, EffectCoverflow]}
                            className="w-full "
                            style={{
                                "--swiper-navigation-size": "20px",
                                padding: '30px',
                                marginTop: '35px'
                            }}
                        >
                            {data.map((item, i) => (

                                <SwiperSlide
                                    className={`w-full ${currentSlide !== i && 'mt-4'}`}
                                    key={i}
                                    onClick={() => setCurrentSlide(i)}

                                >
                                    <div className={`relative h-[330px] md:h-[350px] ${currentSlide === i ? 'bg-white rounded-xl shadow-2xl p-1.5 hover:scale-95 duration-700' : 'opacity-90'}`}>
                                        <img src={item.img} alt='img' className={` w-full h-full ${currentSlide === i && 'rounded-xl'}`} />
                                        <div className="absolute bottom-[25px] right-0 left-0">
                                            {currentSlide !== i && (
                                                <h1 className="font-bold text-center text-white text-base">
                                                    {item.title}
                                                </h1>
                                            )}
                                        </div>
                                    </div>
                                    <div className="relative z-50">

                                        <motion.div

                                            variants={{
                                                visible: { opacity: 1, y: 0 },
                                                hidden: { opacity: 0, y: 70 }
                                            }}
                                            initial="hidden"
                                            animate={currentSlide === i ? "visible" : "hidden"}
                                            transition={{ duration: 1.0 }}

                                        >
                                            {currentSlide === i && (
                                                <div className="bg-white relative z-30 mt-3 p-2 rounded-md shadow-md hover:scale-95 duration-700">

                                                    <h1 className="font-bold text-red-500 text-sm">
                                                        {item.title}
                                                    </h1>
                                                    <p className="text-[15px] my-1 text-gray-600">
                                                        {item.desc}
                                                    </p>
                                                </div>
                                            )}
                                        </motion.div>
                                    </div>

                                </SwiperSlide>

                            ))}



                        </Swiper>
                    </div>
                </StyledStoriesSection>
            </div>
        </motion.div>
    )
}

export default Stories